<template>
  <div>
    <div>
      <label
        v-if="title !== ''"
        class="ml-2 flex items-center justify-between text-neutral-800"
        :class="[
          size === 'small' ? 'text-sm' : '',
          size === 'medium' ? 'text-base' : '',
          size === 'large' ? 'text-lg' : '',
          font === 'normal' ? 'flex items-center justify-between text-neutral-800' : '',
          font === 'bold' ? 'flex items-center justify-between font-extrabold text-neutral-800' : ''
        ]"
      >
        {{ title }}
      </label>
      <label class="ml-2 mb-4 flex items-center justify-between text-xs font-extralight text-neutral-500">
        {{ subtitle || '&nbsp;' }}
      </label>
    </div>

    <div :id="id" class="e-conn-connections-chart highcharts-light" />
  </div>
</template>

<script lang="ts" setup>
import * as Highcharts from 'highcharts';
import { Chart, SeriesOptionsType } from 'highcharts';
import 'highcharts/modules/no-data-to-display';
import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  id: string;
  title: string;
  subtitle?: string;
  series: SeriesOptionsType[];
  size?: 'small' | 'medium' | 'large';
  font?: 'normal' | 'bold';
  heightInPx?: number;
}

const props = withDefaults(defineProps<Props>(), {
  subtitle: '',
  size: 'large',
  font: 'normal',
  heightInPx: 250
});

const { t } = useI18n();

onMounted(() => {
  drawGraph();
});

watch(props, () => drawGraph());

const drawGraph = (): Chart => {
  return Highcharts.chart({
    title: {
      text: ''
    },
    chart: {
      type: 'pie',
      height: props.heightInPx + 'px',
      renderTo: props.id,
      styledMode: true
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      pie: {
        innerSize: '40%', // donut chart
        animation: false,
        dataLabels: {
          enabled: true,
          formatter: function () {
            if (this.y && this.y > 0) {
              return this.name;
            }
            return null; // hides label
          }
        }
      }
    },
    series: props.series,
    accessibility: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    lang: {
      noData: t('common.noData')
    },
    noData: {
      useHTML: true
    }
  });
};
</script>

<style lang="scss">
.e-conn-connections-chart {
  .series-connected {
    fill: theme('colors.primary.300');
    stroke: theme('colors.primary.300');
  }

  .series-inactive {
    fill: theme('colors.neutral.100');
    stroke: theme('colors.neutral.100');
  }
}
</style>
